import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import { RootState } from "../../../../models";
import * as Ajax from "../../app/Ajax";
import { API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP, API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP_BY_SKU } from "../api";

export const fetchShopAvailability = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) => {
    dispatch({
        type: AT.SHOP_PICKER_FETCH_SHOP_AVAILABILITY,
        payload: Ajax.get({ url: API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP }, dispatch),
    });
};

export const fetchShopAvailabilityBySku =
    (skus: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.SHOP_PICKER_FETCH_SHOP_AVAILABILITY,
            payload: Ajax.get({ url: API_URL_FETCH_SHOP_AVAILABILITY_FOR_PICKUP_BY_SKU(skus) }, dispatch),
        });
    };
